import { reloadDatatable } from "../common/datatables";

const props = {
    orderManagementDatatableMarker: '#m-my-account-order-management',
    orderManagementDatatable: '#dt-user-orders'
};

export function initDtUserOrders() {

    if ($(props.orderManagementDatatableMarker).length) {
        dtUserOrders(initUserOrderManagementDatatableEvents);
    }
}

function initUserOrderManagementDatatableEvents() {

    //PURPOSE: sets up the full row click select for the user search dt
    $(props.orderManagementDatatable).off('click').on('click', 'tbody td', function (event) {

        if ($(this).hasClass('dataTables_empty')) {

            //if no results are returned for a datatable it adds the message as a row.
            //as such this event binder still acts when theres no row to click through on.
            //the check above neutralises this issue
            return;
        }

        var userId = $(event.currentTarget).parent('tr').data('id');

        window.location.href = '/manage-account/order-details?id=' + userId;
    });
}

function dtUserOrders(onloadCallback) {

    if ($(props.orderManagementDatatable).length === 0) return false;

    $(props.orderManagementDatatable).DataTable({
        iDisplayLength: 100,
        initComplete: onloadCallback,
        paging: false,
        info: false,
        ordering: true,
        filter: false,
        lengthChange: false,
        serverSide: true,
        deferRender: true,
        ajax: {
            url: '/manage-account/order-list',
            dataSrc: function (data) {

                if (data.responseType === 'SUCCESS')
                    return data.data;
                else
                    responseError(data);
            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.log(textStatus);
            },
            type: 'POST'
        },

        columns: [
            { data: 'orderNumber', name: 'Order Number' },
            { data: 'orderTotal', name: 'Total' },
            { data: 'orderDate', name: 'Order Date' },
            { data: 'orderStatus', name: 'Order Status' },
            {
                name: '',
                data: null,
                sortable: false,
                render: function (o) {

                    return '<div class="mdc-button mdc-button--raised bg-green text-white min-width-200 hidden-xs">View</div>'
                },
                class: 'text-align-right'
            },
        ],

        createdRow: function (row, data, dataIndex) {
            $(row).attr('data-id', data.id);
        }

    });
}

